<template>
  <v-card outlined tile :loading="loading" :disabled="loading">
    <v-card-title class="subtitle-1 font-weight-bold pb-1">
      Flag Filter
    </v-card-title>
    <v-card-subtitle class="caption text--secondary">
      Select flags to filter out from flag dropdowns, context menus, and selections across the app.
    </v-card-subtitle>
    <v-card-text>
      <v-autocomplete
        v-model="selectedFlags"
        :items="sampleFlagTypes"
        item-text="name"
        item-value="uuid"
        label="Flags to Filter Out"
        multiple
        chips
        deletable-chips
        outlined
        dense
        clearable
        hide-details="auto"
        placeholder="Search and select flags..."
      >
        <template v-slot:selection="{ item, selected }">
          <v-chip
            :input-value="selected"
            close
            @click:close="removeFlag(item.uuid)"
            :color="item.color || 'primary'"
            class="white--text ma-1"
            small
          >
            <strong>{{ item.name }}</strong>
          </v-chip>
        </template>
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-action>
              <v-simple-checkbox :value="selectedFlags.includes(item.uuid)"></v-simple-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-chip
                  :color="item.color || 'grey'"
                  class="white--text mr-2"
                  x-small
                  label
                >
                  {{ item.name }}
                </v-chip>
                <span class="caption text--secondary" v-if="item.description">
                  - {{ item.description }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-card-text>
    <v-card-actions class="px-4 pb-3">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        tile
        small
        :loading="saving"
        :disabled="saving || loading"
        @click="saveFilteredFlags"
      >
        Save Flag Filter
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "FlagFilter",
  data() {
    return {
      selectedFlags: [],
      loading: false,
      saving: false,
    };
  },
  computed: {
    sampleFlagTypes() {
      return this.$store.$db().model('sampleFlagTypes').query().orderBy("display_index").all();
    }
  },
  async mounted() {
    await this.loadFilteredFlags();
  },
  methods: {
    removeFlag(uuid) {
      this.selectedFlags = this.selectedFlags.filter(id => id !== uuid);
    },
    async loadFilteredFlags() {
      this.loading = true;
      try {
        if (this.$store.$db().model('sampleFlagTypes').all().length === 0) {
          await this.$store.$db().model('sampleFlagTypes').api().fetch();
        }
        const doc = await this.$firestore.collection("Configs").doc("Belit").get();
        if (doc.exists) {
          const data = doc.data();
          this.selectedFlags = data.filtered_flags || data.manifest_filtered_flags || [];
          this.$store.commit('setFilteredFlags', this.selectedFlags);
        } else {
          this.selectedFlags = this.$store.state.filtered_flags || this.$store.state.manifest_filtered_flags || [];
        }
      } catch (e) {
        console.error("Failed to load flag filter config:", e);
        this.$store.dispatch("showError", "Failed to load flag filter settings");
      } finally {
        this.loading = false;
      }
    },
    async saveFilteredFlags() {
      this.saving = true;
      try {
        await this.$firestore.collection("Configs").doc("Belit").set({
          filtered_flags: this.selectedFlags,
          manifest_filtered_flags: this.selectedFlags
        }, { merge: true });

        this.$store.commit('setFilteredFlags', this.selectedFlags);
        this.$store.dispatch("showSuccess", "Flag filter saved successfully");
      } catch (e) {
        console.error("Failed to save flag filter config:", e);
        this.$store.dispatch("showError", "Failed to save flag filter settings");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
</style>
